import { Outlet, useRouterState } from '@tanstack/react-router';
import { Separator } from '@upme/ui/components/separator';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@upme/ui/components/sidebar';
import { ThemeSwitcher } from '../theme/theme-switcher';
import { AppBreadcrumbs } from './app-breadcrumbs';
import { AppSidebar } from './app-sidebar';

export function AppShell() {
  const isCrm = useRouterState({ select: (state) => /^\/crm(?:\/|$)/.test(state.location.pathname) });
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="min-w-0">
        <header className="sticky top-0 z-10 flex h-14 shrink-0 items-center gap-2 border-b bg-background px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 h-4" />
          {isCrm ? <div id="crm-header-controls" className="min-w-0 flex-1" /> : <AppBreadcrumbs />}
          <div className="ml-auto">
            <ThemeSwitcher />
          </div>
        </header>
        {/* --crm-viewport-h: visible CRM workspace on desktop = 100dvh − header h-14 − main lg:p-4 × 2. */}
        <main
          className={
            isCrm
              ? 'min-w-0 flex-1 overflow-auto p-3 [--crm-viewport-h:calc(100dvh-5.5rem)] lg:p-4'
              : 'flex-1 overflow-auto p-6 lg:p-8'
          }
        >
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
